<template lang="pug">
div.scene
  Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;margin-left: 12px;transform: translateY(-10px);',
    @click='showAIDialog()',v-if='enableAI') AI生成
  Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
    Form(:model="aiForm" :label-width="80")
      FormItem(label="选择模块" :label-width="80")
        Select(v-model="aiForm.pollingCenter_model" placeholder="选择模块名称")
          Option(lable="问卷调查",value="问卷调查") 问卷调查
          Option(lable="质性访谈",value="质性访谈") 质性访谈
      FormItem(label='提示词',prop="stem")
        Input(v-model='aiForm.system' placeholder='请填写提示词'
          type="textarea" :rows="3")
  .topTitle
    span 民意调查中心
    .btns
      Icon(type="md-arrow-dropup",@click="$emit('upData',eachIndex,DATA,)")
      Icon(type="md-arrow-dropdown",@click="$emit('downData',eachIndex,DATA)")
      Icon(type="md-git-branch",@click='logic')
      Icon(type="ios-trash",@click='delModel')
  .talkImg
    img(src="../../assets/case/department/researchCenter.png")
  .plan(v-disabled="seeState")
    Form(:model="form",:label-width="90")
      FormItem(label="选择模块" :label-width="80")
        Select(v-model="form.model" placeholder="选择模块名称")
          //- Option(v-for="(item, index) in modelList",:key="index",:value="item") {{item}}
          Option(lable="问卷调查",value="QUESTIONNAIRESURVEY") 问卷调查
          Option(lable="质性访谈",value="QUALITATIVEINTERVIEWS") 质性访谈
      FormItem(:label="form.model=='问卷调查' ? '问卷资料设置' : '访谈资料设置'" :label-width="110")
      FormItem
        ul.questionList
          li(v-for="(item, index) in form.questionList",:key="index")
            div.left #资料{{index + 1}}
            div.right
              .title
                Input(v-model="item.title",type="textarea",placeholder="请输入内容",:maxlength="500")
              .content
                quill-editor.editor1(v-model='item.content',:options = "editorOption" )
            div.clear
              Icon(type="md-close-circle",@click="deleteData(index)")
      FormItem
        Button.addQuestion(icon="md-add",@click="addData") 添加资料
      FormItem(label="正确答案" :label-width="80")
        CheckboxGroup(v-model="form.trueAnswer")
          Checkbox(v-for='(item, index) in form.questionList',:key="index",:label="index +1")
      FormItem(label="分析问题",prop="title" :label-width="80")
        Input(v-model="form.title",type="textarea",placeholder="请输入内容",style="margin-bottom:10px",:maxlength="500")
      FormItem(label="参考答案",prop="stem" :label-width="80")
        Input(v-model="form.stem",type="textarea",:autosize="{minRows: 2,maxRows: 5}",:maxlength="500" :show-word-limit="true" placeholder="请输入参考答案")
        //- quill-editor.editor1(v-model='form.stem',:options = "editorOption" )
      FormItem(label="答案解析",prop="answer" :label-width="80")
        i-input(v-model.sync="form.answer",
        type="textarea",
        :maxlength="500"
        :autosize="{minRows: 2,maxRows: 5}",
        placeholder="请输入问题答案")
      //- Form-item(label="评分关键词")
      //-   div.tag
      //-     ul(v-if="form.scoringKeywords")
      //-       Tag(closable color="blue",
      //-         v-for="(item, index) in form.scoringKeywords",
      //-         :key="index",
      //-         @on-close="handleClose(index)") {{item}}
      //-       i-button(type="text",v-show='clickAdd',@click="addTag") 点击添加
      //-       Input(:maxlength="10",
      //-         v-show="!clickAdd",
      //-         style="width: 80px",ref="addInput",
      //-         @on-blur='fun_addTag',
      //-         v-model.trim='addTagData',
      //-         @keyup.enter.native="fun_addTag")
      Form-item(label="分值" :label-width="80")
        Input-number(:max="100" :min="0" v-model.sync="form.score")
</template>

<script>
import * as Quill from "quill"; // 引入编辑器
import Bus from "../../utils/bus";

// eslint-disable-next-line prettier/prettier
const fonts = ["SimSun", "SimHei", "Microsoft-YaHei", "KaiTi", "FangSong", "Arial", "sans-serif"];
const Font = Quill.import("formats/font");
Font.whitelist = fonts; // 将字体加入到白名单
Quill.register(Font, true);
export default {
  inject: ["seeState"],
  props: ["assemblyName", "info", "data", "fun_office1", "taskId", "haId", "taId", "cdId"],
  data() {
    return {
      enableAI: false,
      aiDialogVisible: false,
      aiForm: {},
      form: {
        model: "QUESTIONNAIRESURVEY",
        questionList: [
          {
            title: "",
            content: ""
          }
        ],
        trueAnswer: [],
        title: "",
        stem: "",
        answer: "",
        // caseValue: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
        scoringKeywords: [],
        score: 0
      },
      ruleValidate: {
        stem: [{ required: true, message: "问题不能为空", trigger: "blur" }],
        answer: [{ required: true, message: "答案不能为空", trigger: "blur" }]
      },
      addTagData: "",
      clickAdd: true,
      // modelList: ["问卷调查", "质性访谈"],
      // 富文本编辑器配置
      editorOption: {
        placeholder: "请输入内容",
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "image",
              "link",
              { indent: "-1" },
              { indent: "+1" },
              { align: "" },
              { align: "center" },
              { align: "right" },
              { color: [] },
              { background: [] },
              { font: fonts },
              { size: ["small", false, "large", "huge"] }
            ]
          ]
        }
      }
    };
  },
  created() {
    this.assemblyList = this.data || [];
    if (this.fun_office1 !== undefined) {
      this.form = JSON.parse(this.fun_office1);
    }
  },
  computed: {
    caseValue() {
      return this.$store.state.Case.caseValue;
    },
    DATA() {
      return { talkList: this.form, assemblyList: this.assemblyList };
    },
    fun_office() {
      return JSON.stringify(this.form);
    }
  },
  watch: {
    fun_office1: {
      handler(val) {
        if (val) {
          this.form = JSON.parse(this.fun_office1);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    }
  },
  methods: {
    checkEnableAI() {
      this.$http
        .getEnableState()
        .then((res) => {
          if (res.data.success) {
            this.enableAI = res.data.data;
          } else {
            this.enableAI = false;
          }
        })
        .catch(() => {
          this.enableAI = false;
        });
    },
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { dialogue_count: 2, system: "", pollingCenter_model: "问卷调查" };
    },
    generateCase() {
      if (this.haId === "" || this.haId === null || this.haId === undefined) {
        this.$Message.error("无法生成！原因：已存在民意调查中心场景！");
        return;
      }
      const data = {
        inputs: {
          opt_type: "POLLINGCENTER",
          pyId: this.$store.state.Case.basic.id,
          tsId: this.taskId,
          // haId: this.haId,
          score: 2,
          pollingCenter_model: this.aiForm.pollingCenter_model,
          system: this.aiForm.system,
          taId: this.taId,
          cdId: this.haId
        }
      };
      this.$http.generateCase(data).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          if (this.taskId !== this.haId) {
            Bus.$emit("refresh-task", this.taskId);
          } else {
            this.$emit("refresh-query");
          }
        }
      });
    },

    upData(index) {
      // 题目点击向上移动
      if (index === 0) {
        return this.$Message.error("已经是第一个控件啦");
      }

      [this.assemblyList[index], this.assemblyList[index - 1]] = [
        this.assemblyList[index - 1],
        this.assemblyList[index]
      ];

      this.$forceUpdate();
    },
    downData(index) {
      // 题目点击向上移动

      if (index + 1 === this.assemblyList.length) {
        return this.$Message.error("已经是最后一个控件啦");
      }
      [this.assemblyList[index], this.assemblyList[index + 1]] = [
        this.assemblyList[index + 1],
        this.assemblyList[index]
      ];
      this.$forceUpdate();
    },
    // 添加资料
    addData() {
      this.form.questionList.push({
        title: "",
        content: ""
      });
    },
    // 关闭标签
    handleClose(value) {
      this.form.scoringKeywords.splice(value, 1);
    },
    // 删除题目
    delModel() {
      this.$emit("delModel", "POLLINGCENTER");
    },
    // 删除资料
    deleteData(index) {
      this.form.questionList.splice(index, 1);
    },
    // 点击添加标签
    addTag() {
      this.clickAdd = false;
      this.$nextTick(() => {
        this.$refs.addInput.focus();
      });
    },
    // 添加标签
    fun_addTag() {
      const value = this.addTagData.trim();
      if (!value) {
        this.clickAdd = true;
      } else {
        this.form.scoringKeywords.push(value);
        this.clickAdd = true;
        this.addTagData = "";
      }
    }
  },
  mounted() {
    this.checkEnableAI();
    this.haId =
      this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ].HallId;
  }
};
</script>

<style lang="stylus" scoped>
.scene
  width 854px
  padding 16px 32px 60px 32px
  .topTitle
    text-align left
    height 32px
    line-height @height
    position relative
    margin-bottom 16px
    font-size 14px
    font-weight bold
    color rgba(42, 46, 54, 0.8)
    .btns
      position absolute
      right 0
      top 0
      .ivu-icon
        color #3A76D2FF
        font-size 22px
        top 0
        margin-right 12px
        background #F2F5FAFF
        width 24px
        height 24px
        border-radius 4px
        text-align center
        line-height @height
        &:hover
          cursor pointer
  .talkImg
    margin-bottom 24px
    img
      width 100%
  .plan
    text-align left
    font-size 14px
    border-bottom 1px solid rgba(42, 46, 54, 0.3)
    form
      .ivu-form-item
        .ivu-form-item-label
          text-align left
        .ivu-form-item-content
          .tag
            border 1px solid rgb(220, 222, 226)
            text-align left
            border-radius 4px
            padding 4px
            ul
              .ivu-tag
                height 28px
                line-height 28px
                background rgba(58, 118, 210, 1)
                .ivu-tag-text
                  color #FFF !important
          .ivu-select
            width 168px
        &:nth-of-type(3)
          .ivu-form-item-content
            margin-left 0 !important
        &:nth-of-type(4)
          .ivu-form-item-content
            margin-left 0 !important
        &:nth-of-type(5)
          .ivu-form-item-label
            width 70px !important
          .ivu-form-item-content
            margin-left 70px !important
        &:nth-of-type(6)
          .ivu-form-item-label
            width 70px !important
          .ivu-form-item-content
            margin-left 70px !important
        &:nth-of-type(7)
          .ivu-form-item-label
            width 75px !important
          .ivu-form-item-content
            margin-left 75px !important
        &:nth-of-type(8)
          .ivu-form-item-label
            width 70px !important
          .ivu-form-item-content
            margin-left 70px !important
    .set
      padding-bottom 26px
    .questionList
      li
        overflow hidden
        display flex
        margin-bottom 10px
        div
          flex 1
        .left
          flex 0 0 70px
        .right
          margin-right 20px
          div
            input
              width 100%
              border none
          .title
            margin-bottom 10px
        .clear
          flex 0 0 20px
          position relative
          .ivu-icon
            position absolute
            top 50%
            margin-top -10px
            font-size 20px
            color #E72020
            width 20px
            height 20px
    .addQuestion
      margin-left 70px
>>>.ivu-input-type-textarea .ivu-input-word-count
  z-index 100
</style>
